export interface Resume {
  id: number;
	token: string;
  status: ResumeStatus;
  fileName: string;
	fullName: string;
	contactNumber: string;
	email: string;
	gender: string;
	dateOfBirth: Date;
	nationality: string;
	residence: string;
	country: string;
	highestQualification: string;
	currentEmploymentStatus: string;
	availStartDate: Date;
	currentSalary: number;
	expectedSalary: number;
	totalYearsOfExperiences: number;
	languageProficiency: string[];
	skills: string[];
  education: Education[];
  workExperience: WorkExperience[];
  professionalCertificate: ProfessionalCertificate[];
  socialLink: SocialLink[];
  active: boolean;
  version: number;
}

export interface Education {
  courseTitle: string;
  educationLevel: string;
  institutionName: string;
  numberOfYears: string;
}

export interface WorkExperience {
  companyName: string;
  numberOfYears: string;
  title: string;
  roleSummary: string;
  skills: string[];
}

export interface ProfessionalCertificate {
  title: string;
  issuerName: string;
  dateIssued: Date;
}

export interface SocialLink {
  name: string;
  link: string;
}

export enum ResumeStatus {
  FILLED_IN = 'FILLED_IN',
  PARTIALLY_FILLED = 'PARTIALLY_FILLED',
  MISSING_MANDATORY_FIELDS = 'MISSING_MANDATORY_FIELDS',
}

export enum ResumeUploadStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
}

export interface ResumeUpload {
  totalUploads: string[];
  successfulUploads: Resume[];
  failedUploads: string[];
  errors: string[];
  status: ResumeUploadStatus;
}